import styled from 'styled-components';

export const ConnectorDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;

  color: $font-base-color;
  background-color: $bg-color-dark;
  width: 100vw;
  padding: 0px 32px 24px 32px;

  h5 {
    margin-bottom: 16px;
  }

  .connector-type-icon svg {
    width: auto;
    height: 18px;
  }

  .slider-container .MuiTextField-root {
    width: 110px;
  }

  .vehicle-data.is-stopped {
    opacity: 0.5;
  }

  .vehicle-data.is-stopped .icon-filled-container .icon-filled {
    .waves {
      height: 0px;
    }
    &.Bus-class {
      .charge {
        border-radius: 10px 10px 10px 10px;
      }
    }

    &.Sedan-class {
      .charge {
        border-radius: 28px 28px 20px 20px;
      }
    }

    &.Van-class {
      .charge {
        border-radius: 28px 28px 10px 10px;
      }
    }

    &.Camion-class {
      .charge {
        border-radius: 5px;
      }
    }

    &.battery-charging {
      .charge {
        border-radius: 8px 8px 0px 0px;
      }
    }
  }

  @media (min-width: 576px) {
    width: 400px;
  }
`;

export const ConnectorInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  .vehicle-icon {
    svg:not(.circular) {
      width: auto;
      height: 200px;
      z-index: 2;
      // * {
      //   stroke: $white;
      // }
    }
  }
`;
